import Vue from "vue";
import Router from "vue-router";

import GeoLayout from "@/pages/geoSettings/Layout";
import TestLayout from "@/pages/test/Layout";

// modules

Vue.use(Router);
const baseRoutes = [
  {
    path: "/test",
    name: "test",
    component: TestLayout
  },
  {
    path: "/geosettings",
    name: "geotest",
    component: GeoLayout
  }
];

import frontpageRoute from "../pages/frontpage/modules/routes";
import loginRoute from "../pages/login/modules/routes";
import logoutRoute from "../pages/logout/modules/routes";
import privateRoute from "../pages/private/modules/routes";
import registerRoute from "../pages/register/modules/routes";
import userRoute from "../pages/user/modules/routes";
import adminRoute from "../pages/admin/modules/routes";
import store from "../store/store";

const routes = baseRoutes.concat(
  frontpageRoute,
  loginRoute,
  logoutRoute,
  privateRoute,
  registerRoute,
  userRoute,
  adminRoute
);
const router = new Router({
  routes: routes
});

let _UserLogInState = "";
async function isLoggedIn() {
  return new Promise((resolve, reject) => {
    if (store.getters.isLoggedIn && store.getters.authStatus == "success") {
      _UserLogInState = "loggedin";
    } else if (store.getters.isLoggedIn && store.getters.authStatus == "") {
      _UserLogInState = "waitingforcheck";
    } else {
      _UserLogInState = "notloggedin";
    }
    switch (_UserLogInState) {
      case "loggedin":
        resolve(true);
        break;
      case "waitingforcheck":
        store
          .dispatch("loginWithToken")
          .then(resp => {
            resolve(true);
            _UserLogInState = "loggedin";
          })
          .catch(err => {
            console.log(err);
            resolve(false);
          });
        break;
      case "notloggedin":
        resolve(false);
        break;
      default:
        console.log("unknown status");
        reject(false);
    }
  });
}
router.beforeEach((to, from, next) => {
  const history = store.getters.getHistory;
  if (history && !history.passed) {
    history.passed = true;
    store.commit("HISTORY_SET", history);
  } else if (history && history.passed) {
    store.commit("HISTORY_REMOVE");
  }
  const requiresAuth = to.matched.some(rec => rec.meta.requiresAuth);
  if (requiresAuth) {
    isLoggedIn()
      .then(LoggedIn => {
        if (LoggedIn) {
          next();
        } else {
          next({
            name: "login", // back to safety route //
            query: {
              redirectFrom: to.fullPath,
              message: "You need to login to access that feature."
            }
          });
        }
      })
      .catch(ex => {
        alert("unknown error, please refresh your browser");
        next({
          name: "frontpage", // back to safety route //
          query: { redirectFrom: to.fullPath }
        });
      });
  } else {
    next();
  }
});

export default router;
